export default {
  PENDING: {
    value: 'pending',
    label: '未开始',
  },
  ONGOING: {
    value: 'ongoing',
    label: '进行中',
  },
  COMPLETE: {
    value: 'complete',
    label: '已结束',
  }
}
